import './styles.css'
import { SceneManager } from './core/SceneManager'
import { Panel } from './ui/Panel'

function isWebGL2Available(): boolean {
  try {
    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl2')
    return !!gl
  } catch {
    return false
  }
}

function boot(): void {
  const canvas = document.getElementById('glcanvas') as HTMLCanvasElement
  const container = document.getElementById('app')!
  const overlay = document.getElementById('error-overlay')!

  if (!isWebGL2Available()) {
    overlay.classList.remove('hidden')
    return
  }

  const sm = new SceneManager(container, canvas)
  new Panel(sm, document.getElementById('gui-root')!)
  // 调试钩子：浏览器控制台可访问 __atmosbox.debugSample() 等
  ;(window as unknown as Record<string, unknown>).__atmosbox = sm
}

boot()
